export default "__VITE_ASSET__2854113f__"